export const getVariableConditionsCopy = variableConditions =>
  JSON.parse(JSON.stringify(variableConditions));
